import React, {useState} from 'react';
import cn from 'classnames';
import {useTranslation} from 'react-i18next';
import OutsideClickHandler from 'react-outside-click-handler';

import Icon from 'components/acommon/Icon';

import styles from './Language.module.sass';

export type LanguageItem = {
  value: string;
  label: string;
  country: string;
};

export type LanguageProps = {
  className: string;
};

const languageOptions = [
  {
    value: 'en',
    label: 'English',
    country: 'United States',
  },
  {
    value: 'es',
    label: 'Español',
    country: 'Spain',
  },
  {
    value: 'it',
    label: 'Italiano',
    country: 'Italy',
  },
  {
    value: 'de',
    label: 'Deutsch',
    country: 'Germany',
  },
  {
    value: 'fr',
    label: 'Français',
    country: 'France',
  },
  {
    value: 'hu',
    label: 'Magyar',
    country: 'Magyar',
  },
  {
    value: 'ru',
    label: 'Русский',
    country: 'Russia',
  },
  {
    value: 'cs',
    label: 'Čeština',
    country: 'Čeština',
  },
  {
    value: 'bg',
    label: 'Български',
    country: 'Български',
  },
  {
    value: 'pt',
    label: 'Português',
    country: 'Português',
  },
  {
    value: 'ro',
    label: 'Română',
    country: 'Română',
  },
  {
    value: 'ee',
    label: 'Eestlane',
    country: 'Eestlane',
  },
];

const Language = ({className}: LanguageProps) => {
  const {t, i18n} = useTranslation();

  const [visible, setVisible] = useState(false);
  const [activeLanguageOption, setActiveLanguageOption] = React.useState(
    languageOptions[0],
  );
  React.useLayoutEffect(
    function updateLanguageOption() {
      const nextOption = languageOptions.find(option => {
        return option.value === i18n.language.slice(0, 2);
      });

      if (nextOption) {
        setActiveLanguageOption(nextOption);
      }
    },
    [i18n.language],
  );

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    setVisible(false);
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      <div className={cn(className, styles.language, {[styles.active]: visible})}>
        <button className={styles.head} onClick={() => setVisible(!visible)}>
          <Icon name="globe" size="16" className={styles.langIcon} />
          <div className={styles.text}>{t('language')}</div>
        </button>
        <div className={styles.body}>
          <div className={styles.list}>
            {languageOptions.map((x, index) => (
              <button
                className={cn(styles.item, {
                  [styles.active]: activeLanguageOption.value === x.value,
                })}
                key={index}
                onClick={() => changeLanguage(x.value)}
              >
                <div className={styles.title}>{x.label}</div>
                {/* <div className={styles.country}>{x.country}</div> */}
              </button>
            ))}
          </div>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export {Language};
